module.exports = __webpack_public_path__ + "img/clorox.5bee1473.png";